import { makeShowIdTProcTypeLogic } from './helpers';
export var showLogic = makeShowIdTProcTypeLogic({});
